import { ReactNode } from "react"
import { cn } from "../lib/utils"

/** Text colour for a price after a discount, and for the discount itself. */
export const DISCOUNTED_PRICE_CLASS = "text-destructive-foreground"

interface OriginalPriceProps {
  children: ReactNode
  className?: string
}

/**
 * The price before a discount, struck through. Always placed
 * before the discounted price, which uses `DISCOUNTED_PRICE_CLASS`.
 */
export const OriginalPrice = ({ children, className }: OriginalPriceProps) => (
  <span className={cn("text-sm text-muted-foreground line-through", className)}>
    {children}
  </span>
)
